import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"
import { AlertCircle, CheckCircle2, Info, Loader2, TriangleAlert } from "lucide-react"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{
        success: <CheckCircle2 className="h-5 w-5" />,
        error: <AlertCircle className="h-5 w-5" />,
        info: <Info className="h-5 w-5" />,
        warning: <TriangleAlert className="h-5 w-5" />,
        loading: <Loader2 className="h-5 w-5 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:rounded-2xl group-[.toaster]:border group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:shadow-xl group-[.toaster]:px-4 group-[.toaster]:py-3 dark:group-[.toaster]:bg-card sm:group-[.toaster]:max-w-[410px]",
          title: "group-[.toast]:text-[0.95rem] group-[.toast]:font-semibold group-[.toast]:leading-5",
          description: "group-[.toast]:mt-1 group-[.toast]:text-[0.84rem] group-[.toast]:leading-5 group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:rounded-xl group-[.toast]:bg-primary group-[.toast]:px-3 group-[.toast]:py-2 group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:rounded-xl group-[.toast]:bg-secondary group-[.toast]:px-3 group-[.toast]:py-2 group-[.toast]:text-secondary-foreground",
          icon: "group-[.toast]:mr-3 group-[.toast]:mt-0.5",
          success:
            "group-[.toast]:border-emerald-500/35 [&_[data-icon]]:text-emerald-600 dark:[&_[data-icon]]:text-emerald-400",
          error:
            "group-[.toast]:border-rose-500/35 [&_[data-icon]]:text-rose-600 dark:[&_[data-icon]]:text-rose-400",
          info:
            "group-[.toast]:border-sky-500/35 [&_[data-icon]]:text-sky-600 dark:[&_[data-icon]]:text-sky-400",
          warning:
            "group-[.toast]:border-amber-500/35 [&_[data-icon]]:text-amber-600 dark:[&_[data-icon]]:text-amber-400",
          loading:
            "group-[.toast]:border-primary/35 [&_[data-icon]]:text-primary",
        },
      }}
      {...props} />
  );
}

export { Toaster }
